import { Guardian } from '@xaamin/guardian';

Guardian.define('consumo.listar', (user) => {
  return user.can('consumo.listar');
});

Guardian.define('consumo.info', (user) => {
  return user.can('consumo.info');
});

